import { Body1, Spinner, makeStyles, tokens } from '@fluentui/react-components';
import { useLocale } from '../i18n/useLocale';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacingHorizontalM,
    height: '100%',
    color: tokens.colorNeutralForeground3,
  },
});

export function LoadingState({ label }: { label?: string }) {
  const styles = useStyles();
  const { t } = useLocale();
  return (
    <div className={styles.root}>
      <Spinner size="medium" />
      <Body1>{label ?? t('common.loading')}</Body1>
    </div>
  );
}
